import {makeObservable, observable, reaction, runInAction} from "mobx";
import { IMaintenanceConfiguration } from "../configuration/objects/maintenance-configuration.interface";
import { ServiceBase } from "../service-base";
import { IServiceFactory } from "../service-factory.interface";
import { IMaintenanceService } from "./maintenance.service.interface";

export class MaintenanceService extends ServiceBase implements IMaintenanceService {
    constructor(services: IServiceFactory) {
        super(services);

        makeObservable(this, {
            data: observable
        });

        this._loadMaintenancePromise = this._loadMaintenance();

        reaction(() => this.services.application.isActive,
            (isActive) => {
                if(isActive) {
                    this._loadMaintenancePromise = this._loadMaintenance();
                }
        });
    }

    private _loadMaintenancePromise: Promise<void> = Promise.resolve();

    waitForMaintenance(): Promise<void> {
        return this._loadMaintenancePromise;
    }

    data: IMaintenanceConfiguration = {
        enableMaintenanceAnnouncement: false,
        enableMaintenancePage: false,
        startDate: new Date().toISOString(),
        endDate: new Date().toISOString()
    }

    private async _loadMaintenance(): Promise<void> {

        try {
            const response = await this.services.airlineWebapi.getMaintenance();

            runInAction(() => {
                this.data = response;
            });
        } catch (err) {
            this.services.logger.error('Failed to load maintenance', err);
        }
    }

    refresh(): Promise<void> {
        this._loadMaintenancePromise = this._loadMaintenance();
        return this._loadMaintenancePromise;
    }
}
